<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="1200" scrollable persistent>
      <v-card class="rounded-lg">
        <v-card-title>
          {{ _detail.Title }}
        </v-card-title>
        <v-card-text elevation-0>
          <v-card class="elevation-0 pa-2">
            <v-divider></v-divider>
            <v-card-text>
              <div v-html="_detail.Details"></div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="close()">
            {{ $t("consentform.off") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["show", "_detail"],
  data: function () {
    return {};
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogDelete");
        }
      },
    },
  },
  mounted() {

  },
  methods: {
    close() {
      this.$emit("closeDialogDelete");
    },
  },
};
</script>

<style></style>
